'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadedBytes = undefined;

var _fileUploadGetters = require('./fileUploadGetters');

var uploadedBytes = exports.uploadedBytes = function uploadedBytes(attachment) {
  var file = (0, _fileUploadGetters.getFile)(attachment);
  var progress = (0, _fileUploadGetters.getUploadProgress)(attachment);

  if (!file || !progress) {
    return 0;
  }

  return progress / 100 * file.size;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/file-upload/operators/uploadedBytes.js
// module id = 1161
// module chunks = 2 3